
import CommonPopup from "@/components/CommonPopup.vue";
import Cropper from "cropperjs";
import {  Component, Prop , Watch} from "vue-property-decorator";

@Component
export default class ImageCropper extends CommonPopup{
  @Prop() fileList!: Array<Blob>;
  cropper = {} as Cropper ;
  image = {} as HTMLImageElement;

  selectedFileName = new Blob;
  selectedImageIndex = 0 as number;
  croppedImageList = [] as Array<Blob>;
  cropFirst = false;

  get getFileList(){
    return this.fileList;
  }

  //최종 저장
  complete(){
    if(!this.cropFirst){
      return;
    }
      this.$emit("crop:image",this.croppedImageList)
      this.cropFirst = false;
      this.$emit('update:opened', false);

  }

 //이미지 크롭 메소드
  async cropImage(index: number, file: Blob){

    this.cropper.getCroppedCanvas().toBlob((blob: Blob | null) => {
      this.croppedImageList[this.selectedImageIndex] = blob!;
    
      this.selectedImageIndex = index;
      this.selectedFileName = file;
      this.cropper.replace(this.getSrcUrl( this.croppedImageList[this.selectedImageIndex]))

    });
    this.cropper.clear();
  }

  //그냥 닫기 버튼 눌렀을때
  onClickCloseModal(){
    this.$emit("crop:image");
    this.$emit('update:opened', false);
  }

  //blob 타입을 url로 만들어서 화면에 보여줌
  getSrcUrl(val: Blob): string{
    return  window.URL.createObjectURL(val);
  }

  ready(){
    this.image = this.$refs.images as HTMLImageElement; 
    this.cropper = new Cropper( this.image,{    
              restore: true,
              guides: true,
              center: true,
              highlight: true,
              autoCrop: false,
              aspectRatio: 2/3,
              viewMode: 2, 
              cropBoxResizable: true,
              zoomable: true,
    crop: (event: Cropper.CropEvent) => {
      this.cropper.crop();
    },
  })
  }

  // 크롭완료 버튼 클릭시 해당 이미지 크롭
  finishCroppedImageList(){
    this.cropImage(this.selectedImageIndex, 
    this.croppedImageList[this.selectedImageIndex])
    this.cropFirst = true
  }


  mounted(){
    if(this.fileList.length > 0){     
      this.selectedFileName = this.getFileList[0];   
      this.croppedImageList = this.fileList;
      this.$nextTick(()=>{this.ready()})
    }
  }
}
